<template>
    <div class="payment-credit">
        <h4 v-if="!hideRadio">
            <input
                type="radio"
                :checked="selected"
                @click="$emit('selected')"
            >
            Use a credit card
        </h4>
        <template v-show="selected">
            <fieldset
                class="cc"
                v-if="!last4"
            >
                <my-input
                    type="div"
                    label="Card number"
                    :required="true"
                    id="cardNumber"
                    :inputClass="['stripeElementContainer','loading']"
                    :validator="$v.cardElements.cardNumber"
                    :errorMessage="cardElements.cardNumber.message"
                />
                <my-input
                    type="div"
                    label="CVC"
                    :required="true"
                    id="cardCvc"
                    :inputClass="['stripeElementContainer','loading']"
                    :validator="$v.cardElements.cardCvc"
                    :errorMessage="cardElements.cardCvc.message"
                />
                <my-input
                    type="div"
                    label="Expiration"
                    :required="true"
                    id="cardExpiry"
                    :inputClass="['stripeElementContainer','loading']"
                    :validator="$v.cardElements.cardExpiry"
                    :errorMessage="cardElements.cardExpiry.message"
                />
            </fieldset>
            <p v-else class="last-4-message">
                Saved card ending in {{ last4 }}.
            </p>
        </template>
    </div>
</template>

<script>
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';
import { validationMixin } from 'vuelidate';
import MyInput from './form/MyInput';

const truthy = (value) => value;

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
};

export default {
    components: {
        MyInput,
    },
    mixins: [ validationMixin ],
    props: {
        stripeKey: {
            type: String,
        },
        selected: {
            type: Boolean,
        },
        hideRadio: {
            type: Boolean,
            default: false,
        },
        last4: {
            type: String,
        },
        // complete: {
        //     type: Boolean,
        //     default: false,
        // },
    },
    data() {
        return {
            stripe: null,
            cardElements: {
                cardNumber: {
                    element: null,
                    valid: false,
                    message: '',
                },
                cardExpiry: {
                    element: null,
                    valid: false,
                    message: '',
                },
                cardCvc: {
                    element: null,
                    valid: false,
                    message: '',
                },
            },
        };
    },
    validations: {
        cardElements: {
            cardNumber: {
                valid: { truthy },
            },
            cardExpiry: {
                valid: { truthy },
            },
            cardCvc: {
                valid: { truthy },
            },
        },
    },
    computed: {
    },
    watch: {
        $v: {
            deep: true,
            handler: function(cur, prev) {
                this.$emit('valid', this.$v.cardElements.cardNumber.valid.$model
                    && this.$v.cardElements.cardCvc.valid.$model
                    && this.$v.cardElements.cardExpiry.valid.$model
                );
            },
        }
    },
    methods: {
        handleCardEvent(event) {
            this.$v.cardElements[event.elementType].$touch();
            this.cardElements[event.elementType].message = event.error ? event.error.message : '';
            this.cardElements[event.elementType].valid = event.complete;
        },
        getToken() {
            return this.stripe.createToken(this.cardElements.cardNumber.element);
        },
    },
    mounted: async function() {
        let vue = this;
        this.stripe = await loadStripe(this.stripeKey);
        let stripeElements = this.stripe.elements();
        let options = {
            style: {
                base: {
                    fontFamily: 'Open Sans',
                    fontSize: '16px',
                    color: '#4a4a4a',
                    // '::placeholder': {
                    //     color: '#ff0000',
                    // },
                }
            },
        };

        // stripe element validation
        for (const prop in this.cardElements) {
            this.cardElements[prop].element = stripeElements.create(prop, options);
            this.cardElements[prop].element.mount('#' + prop);
            this.cardElements[prop].element.addEventListener('change', this.handleCardEvent);
            this.cardElements[prop].element.addEventListener('ready', function(evt) {
                document.getElementById(evt.elementType).classList.remove('loading');
                vue.cardElements[evt.elementType].loading = false;
            });

            this.cardElements[prop].complete = false;
            // this.cardElements[prop].valid = false;
        }
    },
}
</script>

<style lang="scss">
.payment-credit {
    .last-4-message {
        margin-left: 2em !important;
        font-size: 120%;
        margin-top: -20px !important;
        font-weight: bold;
        color: #8a5b0a;
    }

    .cc .label {
        width: 7em;
    }

    .loading {
        background-color: #dddddd;
        position: relative;
        overflow: hidden;
    }

    .loading::before {
        content: '';
        display: block;
        position: absolute;
        left: -150px;
        top: 0;
        height: 100%;
        width: 150px;
        background: linear-gradient(to right, transparent 0%, #eeeeee 50%, transparent 100%);
        animation: load 1.5s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
    }

    @keyframes load {
        from {
            left: -150px;
        }
        to {
            left: 100%;
        }
    }

    .StripeElement {
        width: 20em;
    }

    .StripeElement--invalid,
    .StripeElement--empty.dirty {
        border-color: red;
    }

    .__PrivateStripeElement {
        width: 100%;
    }

    .help.is-danger {
        width: 100%;
    }
}
</style>
